<template>
	<div class="sidebar-last-changes">
		<b-table hover :items="items" :fields="fields">
			<template slot="type" scope="cell">
				<img v-if="cell.value === 'creation'"
				     class="type-icon"
				     src="~@/assets/img/changes/creation.svg" :alt="cell.value" />
				<img v-if="cell.value === 'creation_template_set'"
				     class="type-icon"
				     src="~@/assets/img/changes/creation_template_set.svg" :alt="cell.value" />
				<img v-if="cell.value === 'status_change'"
				     class="type-icon"
				     src="~@/assets/img/changes/status_change.svg" :alt="cell.value" />
				<img v-if="cell.value === 'image_delete'"
				     class="type-icon"
				     src="~@/assets/img/changes/image_delete.svg" :alt="cell.value" />
				<img v-if="cell.value === 'image_upload'"
				     class="type-icon"
				     src="~@/assets/img/changes/image_upload.svg" :alt="cell.value" />
				<img v-if="cell.value === 'image_change'"
				     class="type-icon"
				     src="~@/assets/img/changes/image_change.svg" :alt="cell.value" />
				<img v-if="cell.value === 'text_change'"
				     class="type-icon"
				     src="~@/assets/img/changes/text_change.svg" :alt="cell.value" />
				<img v-if="cell.value === 'site_delete'"
				     class="type-icon"
				     src="~@/assets/img/changes/site_delete.svg" :alt="cell.value" />
				<img v-if="cell.value === 'site_add'"
				     class="type-icon"
				     src="~@/assets/img/changes/site_add.svg" :alt="cell.value" />
				<img v-if="cell.value === 'site_sort'"
				     class="type-icon"
				     src="~@/assets/img/changes/site_sort.svg" :alt="cell.value" />
				<img v-if="cell.value === 'label_add'"
				     class="type-icon"
				     src="~@/assets/img/changes/label_add.svg" :alt="cell.value" />
				<img v-if="cell.value === 'assign_to_person'"
				     class="type-icon"
				     src="~@/assets/img/changes/assign_to_person.svg" :alt="cell.value" />
				<img v-if="cell.value === 'translation_request'"
				     class="type-icon"
				     src="~@/assets/img/changes/translation_request.svg" :alt="cell.value" />
				<img v-if="cell.value === 'translation_finished'"
				     class="type-icon"
				     src="~@/assets/img/changes/translation_finished.svg" :alt="cell.value" />
				<img v-if="cell.value === 'assignment_request'"
				     class="type-icon"
				     src="~@/assets/img/changes/assignment_request.svg" :alt="cell.value" />
				<img v-if="cell.value === 'assignment_feedback'"
				     class="type-icon"
				     src="~@/assets/img/changes/assignment_feedback.svg" :alt="cell.value" />
				<img v-if="cell.value === 'assignment_finished'"
				     class="type-icon"
				     src="~@/assets/img/changes/assignment_finished.svg" :alt="cell.value" />
				<img v-if="cell.value === 'synchronization_request'"
				     class="type-icon"
				     src="~@/assets/img/changes/synchronization_request.svg" :alt="cell.value" />
				<img v-if="cell.value === 'synchronization'"
				     class="type-icon"
				     src="~@/assets/img/changes/synchronization.svg" :alt="cell.value" />
				<img v-if="cell.value === 'empty_copy'"
				     class="type-icon"
				     src="~@/assets/img/changes/creation.svg" :alt="cell.value" />
				<img v-if="cell.value === 'basedata_change'"
				     class="type-icon"
				     src="~@/assets/img/changes/basedata_change.svg" :alt="cell.value" />
				<img v-if="cell.value === 'unknown'"
				     class="type-icon"
				     src="~@/assets/img/changes/error.svg" :alt="cell.value" />
			</template>
		</b-table>
	</div>
</template>
<script>
/* eslint no-underscore-dangle: [2, { "allow": ['_cellVariants'] }] */

import moment from 'moment';

export default {
	name: 'ErcoSidebarLastChangesMolecule',

	props: {
		data: {
			type: String,
		},
	},

	data() {
		return {
			fields: {
				type: {
					label: '',
				},
				date: {
					label: 'Datum',
				},
				time: {
					label: 'Uhrzeit',
					class: 'text-center',
				},
				user: {
					label: 'User',
				},
				action: {
					label: 'Aktion',
					formatter: 'actionFormatter',
				},
			},
		};
	},

	computed: {
		items() {
			const dateFormat = 'DD.MM.YYYY';
			const timeFormat = 'HH:mm:ss';

			const items =
				this.data
					.split(/\n\n|<br \/>|\s(?=\d{4}-\d{2}-\d{2})/)
					.filter(item => (item.trim().length > 0))
					.reverse()
					.map((item) => {
						const cleanedItem = item.trim();
						const actionObj = {
							type: 'default',
							date: null,
							time: null,
							user: '',
							action: '',
							_cellVariants: {},
						};

						const datedActionRegexp = /^(\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2})\s*-\s*(.*?):([\s\S]*){0,1}$/;
						const datedAltActionrRegexp = /^(\d{1,2}).(\d{1,2}).(\d{4})\s*(\d{1,2}:\d{1,2}:\d{1,2}){0,1}\s*-\s*(.*?):([\s\S]*){0,1}$/;
						const createdRegexp = /Angelegt am (\d{2}\. \w+ \d{4}) von (.*)/i;
						const emptyCopyRegexp = /Leerkopie durch (.*?) /i;
						const dateOnlyRegexp = /^(\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2})\s*$/;

						const datedActionMatch = cleanedItem.match(datedActionRegexp);
						const datedAltActionMatch = cleanedItem.match(datedAltActionrRegexp);
						const createdMatch = cleanedItem.match(createdRegexp);
						const emptyCopyMatch = cleanedItem.match(emptyCopyRegexp);
						const dateOnlyMatch = cleanedItem.match(dateOnlyRegexp);

						if (datedActionMatch) {
							const mDate = moment(datedActionMatch[1]);
							actionObj.date = mDate.format(dateFormat);
							actionObj.time = mDate.format(timeFormat);
							actionObj.user = (datedActionMatch[2] || '-').trim();
							actionObj.action = (datedActionMatch[3] || '').trim().split(',').join(', ')
												.replace(/(.*[\s(?!-)]\d{4,} )/, '');
						} else if (datedAltActionMatch) {
							const daam = datedAltActionMatch;
							const mDate = moment(`${daam[3]}-${daam[2]}-${daam[1]} ${daam[4] ? daam[4] : ''}`);
							actionObj.date = mDate.format(dateFormat);
							actionObj.time = daam[4] ? mDate.format(timeFormat) : '-';
							actionObj.user = (datedAltActionMatch[5] || '-').trim();
							actionObj.action = (datedAltActionMatch[6] || '').trim().split(',').join(', ')
												.replace(/(.*[\s(?!-)]\d{4,} )/, '');
						} else if (createdMatch) {
							actionObj.type = 'creation';
							const mDate = moment(createdMatch[1]);
							actionObj.date = mDate.format(dateFormat);
							actionObj.time = '-';
							actionObj.user = (createdMatch[2] || '').trim();
							actionObj.action = 'Objekt angelegt';
						} else if (emptyCopyMatch) {
							actionObj.user = (emptyCopyMatch[1] || '').trim();
							actionObj.action = cleanedItem;
						} else if (dateOnlyMatch) {
							const mDate = moment(dateOnlyMatch[1]);
							actionObj.date = mDate.format(dateFormat);
							actionObj.time = mDate.format(timeFormat);
							actionObj.user = '-';
							actionObj.action = '-';
							actionObj.type = 'unknown';
						} else {
							 /* TODO: Use (better) logging; 'Unknown change-history pattern for', cleanedItem */
						}

						if (actionObj.user === this.$store.state.user.username) {
							actionObj._cellVariants = { ...actionObj._cellVariants, user: 'info' };
						}

						if (actionObj.action.indexOf('Seiten anlegen aus Vorlagenset') > -1) {
							actionObj.type = 'creation_template_set';
						} else if (actionObj.action.indexOf('Status') > -1 ||
						           actionObj.action.indexOf('Objekdaten geändert:') > -1) {
							actionObj.type = 'status_change';
						} else if (actionObj.action.indexOf('Bild gelöscht') > -1) {
							actionObj.type = 'image_delete';
						} else if (actionObj.action.indexOf('Bild hochgeladen') > -1) {
							actionObj.type = 'image_upload';
						} else if (actionObj.action.indexOf('Bild geändert') > -1) {
							actionObj.type = 'image_change';
						} else if (actionObj.action.indexOf('Text geändert') > -1) {
							actionObj.type = 'text_change';
						} else if (actionObj.action.indexOf('Seite loeschen') > -1) {
							actionObj.type = 'site_delete';
						} else if (actionObj.action.indexOf('Seite anlegen') > -1) {
							actionObj.type = 'site_add';
						} else if (actionObj.action.indexOf('Seite sortieren') > -1) {
							actionObj.type = 'site_sort';
						} else if (actionObj.action.indexOf('Tag hinzugefügt') > -1) {
							actionObj.type = 'label_add';
						} else if (actionObj.action.indexOf('Weitergegeben') > -1) {
							actionObj.type = 'assign_to_person';
						} else if (actionObj.action.indexOf('Übersetzung angefordert') > -1) {
							actionObj.type = 'translation_request';
						} else if (actionObj.action.indexOf('Übersetzung wurde abgeschlossen') > -1) {
							actionObj.type = 'translation_finished';
						} else if (actionObj.action.indexOf('angefordert') > -1) {
							actionObj.type = 'assignment_request';
						} else if (actionObj.action.indexOf('eedback') > -1) {
							actionObj.type = 'assignment_feedback';
						} else if (actionObj.action.indexOf('erteilt') > -1) {
							actionObj.type = 'assignment_finished';
						} else if (actionObj.action.indexOf('Synchronisierung veranlasst') > -1) {
							actionObj.type = 'synchronization_request';
						} else if (actionObj.action.indexOf('Objekt synchronisiert') > -1) {
							actionObj.type = 'synchronization';
						} else if (actionObj.action.indexOf('Leerkopie') > -1) {
							actionObj.type = 'empty_copy';
						} else if (actionObj.action.indexOf('Stammdaten geändert:') > -1) {
							actionObj.type = 'basedata_change';
						}

						return {
							...actionObj,
						};
					});

			return items;
		},
	},

	methods: {
		actionFormatter(value) {
			const subItems = value.split('\n');

			if (subItems.length > 0) {
				const headItem = subItems.shift();
				const tailItems = subItems.map(currItem => `<li>${currItem}</li>`);

				return `${headItem}<ul>${tailItems.join()}</ul>`;
			}

			return value;
		},
	},
};
</script>
<style lang="scss">
.sidebar-last-changes {
	& .-list {
		padding-top: 1.5rem;
		font-size: 0.9rem;
	}

	& td {
		&.text-center {
			text-align: center;
		}
		& > .type-icon {
			width: 20px;
			height: 20px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// LastChanges.vue?fdb56782